import { useState } from 'react';

export default function useProfileImage({ avatarLink, onError = () => {} }) {
  const [profileImage, setProfileImage] = useState(null);

  const fetchProfileImage = () => {
    if (avatarLink?.url?.().startsWith('https://static.facetwealth.com')) {
      setProfileImage(avatarLink.url());
    } else if (avatarLink) {
      avatarLink.Get({ raw: true })
        .then((res) => {
          res.blob().then((blob) => {
            const reader = new FileReader();
            reader.onload = () => {
              const dataUrl = reader.result;
              const base64 = dataUrl.split(',')[1];
              setProfileImage(`data:image/jpeg;base64,${base64}`);
            };
            reader.readAsDataURL(blob);
          });
        })
        .catch((err) => {
          // Most clients will probably not have a profile image
          if (err.status !== 404) {
            console.error(err); // eslint-disable-line no-console
          }
          onError(err);
        });
    } else {
      setProfileImage(null);
    }
  };

  const clearProfileImage = () => {
    setProfileImage(null);
  };

  return {
    profileImage,
    fetchProfileImage,
    clearProfileImage,
  };
}
